import { render, staticRenderFns } from "./SspGroup.vue?vue&type=template&id=38dd9d86&scoped=true&"
import script from "./SspGroup.vue?vue&type=script&lang=js&"
export * from "./SspGroup.vue?vue&type=script&lang=js&"
import style0 from "./SspGroup.vue?vue&type=style&index=0&id=38dd9d86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dd9d86",
  null
  
)

export default component.exports